<template>
	<div class="error-404">
		<t-error-500 :back-route="{ name: $routerName.INSTALL_APP }" />
	</div>
</template>

<script>

export default {
    name: "Error",
    metaInfo: {
        title: '500'
    },
	data: () => ({
		sentryId: ''
	}),
	created(){
        this.sentryId = this.$route.query && this.$route.query.sentryId || ''
	}
}
</script>
<style lang="scss">
	.error-404{
		.error{
			&__description{
				p{
					color: $text-color-secondary;
				}
			}
		}
	}
</style>
